var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AdminTableOfContentsDrawer',{attrs:{"value":_vm.isSupportNavbarOpen,"sections":_vm.faqsByTopic,"item-text-key":"question"},on:{"input":function($event){_vm.isSupportNavbarOpen = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }